import { useState } from 'react';
import { useEventListener } from '@nike/privacy-shared-react';
import type { ContextFrameNamesModal } from '@nike/privacy-types';

import { getPrivacyCoreCustomEventNames } from '../helpers/customEventNames';

/**
 * @name useInitializePrivacyCoreError
 * @description Hook which uses to get privacy core error state
 * @param {ContextFrameNamesModal | undefined} contextFrameName - a namespace to retrieve interactions from
 * @returns {boolean}
 */
export const useInitializePrivacyCoreError = (
  contextFrameName: ContextFrameNamesModal | undefined,
): boolean => {
  const [isErrorDisplayed, setIsErrorDisplayed] = useState(false);

  const privacyCoreCustomEventNames = getPrivacyCoreCustomEventNames(contextFrameName);

  useEventListener(privacyCoreCustomEventNames.INITIALIZE_ERROR, () => {
    setIsErrorDisplayed(true);
  });
  useEventListener(privacyCoreCustomEventNames.PERMISSIONS_GET_ERROR, () => {
    setIsErrorDisplayed(true);
  });
  useEventListener(privacyCoreCustomEventNames.CONTEXT_FRAMES_GET_ERROR, () => {
    setIsErrorDisplayed(true);
  });

  return isErrorDisplayed;
};
